import styles from './style.module.scss';
import { useGameStore, useGlobalStore } from 'shared/store';
import {
  COMMON_PRELOAD_ASSETS,
  DEFAULT_FINGER_SLIDER_CONFIG,
  getDonutImage,
} from 'shared/constants';
import { DonutSize } from 'shared/types';
import { StarsMain } from 'components/lottie';
import { audioManager } from 'shared/service/audio';

export const UserSizeDonut = ({ onGameStart }: { onGameStart: () => void }) => {
  const user = useGlobalStore((state) => state.user);
  const gameReady = useGameStore((state) => state.gameReady);
  const resetGameState = useGameStore((state) => state.resetGameState);

  const fingerSize = (parseInt(user.finger_size || '') ||
    DEFAULT_FINGER_SLIDER_CONFIG.min) as DonutSize;

  const onClick = async () => {
    if (gameReady) {
      // await audioManager.initialize(); // same in session-cooldown-timer
      resetGameState();
      // navigate(ROUTES.SESSION);
      onGameStart();
    }
  };

  return (
    <div>
      <div className={styles.userSizeDonutRoot}>
        <div className={styles['pink-donut-container']}>
          <div className={`${styles['pink-donut-outer-ring']} ${gameReady ? styles.pulse : ''}`}>
            <div className={styles['pink-donut-inner-ring']} onClick={onClick}>
              <div
                className={styles.donutShadow}
                style={{
                  width: fingerSize * 1.35,
                  height: fingerSize * 1.35,
                }}
              />
              <img
                src={getDonutImage('pink', fingerSize as any) || getDonutImage('pink', 44)}
                alt="pink-donut"
                className={styles['pink-donut']}
                width={160}
                height={160}
              />
            </div>
          </div>
        </div>
        <div className={styles.starsContainer}>
          <StarsMain />
        </div>
      </div>
    </div>
  );
};
